import { Unit } from "uom";
// DeltaDewPointTemperature
export var DeltaCelsiusDewPoint = Unit.createBase("DeltaCelsiusDewPoint", "DeltaDewPointTemperature", "dp°C");
export var DeltaFahrenheitDewPoint = Unit.timesNumber("DeltaFahrenheitDewPoint", 5.0 / 9.0, DeltaCelsiusDewPoint);
//# sourceMappingURL=delta-dew-point-temperature.js.map